export enum KNOWN_ERRORS {
  PASSWORD_TOO_WEAK = 'PasswordStrengthError: Password is too weak',
  USER_EXISTS = 'The user already exists.',
  EMAIL_INVALID = 'email_invalid',
  PASSWORD_TOO_SHORT = 'password_too_short',
  FIRST_NAME_MUST_EXIST = 'first_name_must_exist',
  LAST_NAME_MUST_EXIST = 'last_name_must_exist',
  NO_CLIENTS_SPECIFIED = 'no_clients_specified',
}
